import React, { useContext, useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Form, Row, Tabs, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import TitlePage from 'components/theme_components/Title';
import Title from 'components/Title';
import DF from 'DisplayFramework';

import {
  addProduct,
  getProductConfigByPrcode,
  ProductConfig,
  updateProduct,
} from 'services/parametersService';
import { AuthContext } from 'components/Auth/Auth';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notifications from 'components/theme_components/Notifications';
import ParListSelect from 'components/ParListSelect';
import ProductFamilyMGTransfer from './ProductFamilyMGTransfer';

const { TabPane } = Tabs;

const ProductFamilyDetails = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const { data: values, refetch } = useQuery<ProductConfig>(
    `getProductConfigByPrcode/${id}`,
    () =>
      getProductConfigByPrcode({ prcode: id! }).then((res: any) => res.data),
    {
      enabled: !!id,
    }
  );

  const [form] = useForm();
  const fieldName = 'products';
  const navigate = useNavigate();
  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    }
  }, [form, values]);
  const { isInspect } = useContext(AuthContext);

  /*const handleSubmit = () => {
    const queryClient = useQueryClient();
    const request: any = {
      prcode: form.getFieldValue('prcode'),
      prlabel: form.getFieldValue('prlabel'),
      financedcategory: form.getFieldValue('financedcategory'),
    };
    if (!id) {
      return addProduct({ parProductrequest: request }).then((res) => {
        if (res.code === '200') {
          Notifications({
            status: 'success',
            message: res.message,
            description: res.description,
            duration: 3,
            placement: 'top',
          });
          navigate(`/configuration-sfs/productsfamily/${res.data.prcode}`);
          refetch();
        } else {
          Notifications({
            status: 'error',
            message: res.message,
            description: res.description,
            duration: 3,
            placement: 'top',
          });
        }
      });
    } else {
      return updateProduct({ parProductrequest: request }).then((res) => {
        if (res.code === '200') {
          Notifications({
            status: 'success',
            message: res.message,
            description: res.description,
            duration: 3,
            placement: 'top',
          });
          refetch();
        } else {
          Notifications({
            status: 'error',
            message: res.message,
            description: res.description,
            duration: 3,
            placement: 'top',
          });
        }
      });
    }
  };*/
  const queryClient = useQueryClient();
  const handleSubmit = () => {
    const request: any = {
      prcode: form.getFieldValue('prcode'),
      prlabel: form.getFieldValue('prlabel'),
      financedcategory: form.getFieldValue('financedcategory'),
    };

    const operation = !id ? addProduct : updateProduct;

    return operation({ parProductrequest: request }).then((res) => {
      if (res.code === '200') {
        Notifications({
          status: 'success',
          message: res.message,
          description: res.description,
          duration: 3,
          placement: 'top',
        });

        if (!id) {
          queryClient.setQueryData(['getProductConfigList'], (oldData: any) => {
            if (oldData) {
              return [res.data, ...oldData];
            }
            return [res.data];
          });

          navigate(`/configuration-sfs/productsfamily/${res.data.prcode}`);
        } else {
          refetch();
          navigate('/configuration-sfs');
        }
      } else {
        Notifications({
          status: 'error',
          message: res.message,
          description: res.description,
          duration: 3,
          placement: 'top',
        });
      }
    });
  };
  return (
    <DF.Provider pagcode="productlist">
      <div className="bg-color-gray transferSFS">
        <TitlePage
          level={2}
          comcode="ProductFamilyDetails"
          bgColor="purple"
          noTitleOverlay
        />

        <Form form={form} layout="vertical">
          <div className="container">
            <Row
              className="mb-4 ut-wizard-form"
              gutter={24}
              justify="center"
              align="stretch"
            >
              <Col span={20}>
                <Tabs className="silos">
                  <TabPane
                    forceRender
                    tab={
                      <GetLabel
                        label="prfamilyGeneralData"
                        className="font-size-15"
                      />
                    }
                    key="1"
                  >
                    <Title
                      comcode="infoproductfamily"
                      level={4}
                      className="ut-updateTP-title mb-7 mt-10"
                    />
                    <Row justify="space-between">
                      <FormInput
                        name="prcode"
                        comcode="productfamily"
                        col
                        xs={24}
                        lg={11}
                      >
                        <Input maxLength={10} disabled={!!id}/>
                      </FormInput>
                      <FormInput name="financedcategory" col xs={24} lg={11}>
                        <ParListSelect parcode="FINCAT" />
                      </FormInput>

                      <FormInput
                        name="prlabel"
                        comcode="productdescription"
                        col
                        xs={24}
                        lg={24}
                      >
                        <Input />
                      </FormInput>
                    </Row>
                    <Row justify="end" className="mt-7">
                      <ButtonLink
                        comcode="Annuler"
                        className="ut-btn-bordred"
                        onClick={() => navigate(`/configuration-sfs`)}
                      />

                      <ButtonLink
                        type="primary"
                        comcode="validate"
                        htmlType="submit"
                        className="ut-reset-btn"
                        iconPosition="end"
                        onClick={() => handleSubmit()}
                      />
                    </Row>
                  </TabPane>
                  <TabPane
                    forceRender
                    tab={
                      <GetLabel
                        label="prfamilymgtransfer"
                        className="font-size-15"
                      />
                    }
                    key="2"
                    disabled={!id}
                  >
                    {' '}
                    <ProductFamilyMGTransfer prcode={values?.prcode ?? ''} />
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </DF.Provider>
  );
};

export default ProductFamilyDetails;
